<div class="container" (clickOutside)="sluit()" [ngStyle]="{'top.px': top}">
  <div *ngFor="let vak of (this.store.getVestigingVakken() | async)" (click)="toggleKoppeling(vak)" class="vak">
    <div class="checkbox {{isSelected(vak) ? 'selected' : 'not-selected'}}"></div>
    <div class="pill-light">{{vak.afkorting}}</div>
    <div class="bodyContent">{{vak.naam}}</div>
  </div>
</div>
